import React from 'react';
import { SvgIcon, SvgIconProps } from '@mui/material';

export const TikTokIcon = (props: SvgIconProps) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <path d="M16.6 5.82s.51.5 0 0A4.278 4.278 0 015.4 5.82C4.1 4.5 4.1 2.37 5.4 1.06 6.7-.25 8.84-.25 10.16 1.06c.63.62 1.109 1.39 1.39 2.24h3.17v7.54c0 1.45 1.19 2.64 2.64 2.64s2.64-1.19 2.64-2.64l-.01-3.89h1.98c1.2-.01 2.17-.98 2.17-2.18s-.97-2.17-2.17-2.17h-1.98c-.06-2.2-.93-4.27-2.41-5.79-1.91-1.91-4.54-2.84-7.18-2.64-4.47.34-8.14 3.98-8.52 8.45-.26 3.02.87 5.88 3.03 8.04s5.02 3.29 8.04 3.03c4.47-.38 8.11-4.05 8.45-8.52.19-2.64-.73-5.27-2.64-7.18z" />
  </SvgIcon>
);

export const GCCIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-7 12h-2v-2h2v2zm0-4h-2V6h2v4z" />
  </SvgIcon>
);

export const DMIcon = (props: SvgIconProps) => (
  <SvgIcon {...props}>
    <path d="M20 2H4c-1.1 0-1.99.9-1.99 2L2 22l4-4h14c1.1 0 2-.9 2-2V4c0-1.1-.9-2-2-2zm-2 12H6v-2h12v2zm0-3H6V9h12v2zm0-3H6V6h12v2z" />
  </SvgIcon>
);
